import { render, staticRenderFns } from "./UpdateContactView.vue?vue&type=template&id=2e9f03fa&scoped=true&"
import script from "./UpdateContactView.vue?vue&type=script&lang=ts&"
export * from "./UpdateContactView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9f03fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e9f03fa')) {
      api.createRecord('2e9f03fa', component.options)
    } else {
      api.reload('2e9f03fa', component.options)
    }
    module.hot.accept("./UpdateContactView.vue?vue&type=template&id=2e9f03fa&scoped=true&", function () {
      api.rerender('2e9f03fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/contacts/management/views/UpdateContactView.vue"
export default component.exports